(ns basic-components.email-content
  (:require
   [common.localization :as loc]
   [frontend.utils :as fu]
   [ui.components.rich-text.tiptap :as tiptap]))

(defn view
  [{:keys [from to cc subject body]}]
  [:div.email-content
   [:div.email-content__header
    [:div.d-sm-flex.align-items-center.pb-2.pb-sm-1
     [:div.email-content__header-left.pb-1.pb-sm-0 (loc/tr :email/from)]
     [:div.email-content__header-right from]]
    [:div.d-sm-flex.align-items-center.pb-2.pb-sm-1
     [:div.email-content__header-left.pb-1.pb-sm-0 (loc/tr :email/to)]
     [:div.email-content__header-right to]]
    (when cc
      [:div.d-sm-flex.align-items-center.pb-2.pb-sm-1
       [:div.email-content__header-left.pb-1.pb-sm-0 (loc/tr :email/cc)]
       [:div.email-content__header-right cc]])
    [:div.d-sm-flex.align-items-center.pb-1
     [:div.email-content__header-left.pb-1.pb-sm-0 (loc/tr :email/subject)]
     [:div.email-content__header-right subject]]]
   [:div.email-content__body
    [:div
     [tiptap/viewer
      {:value (fu/eml-txt-body->hyperlinks body)}]]]])
